import { ReactElement } from 'react';
import { CatModal } from '@blocks-react/components/Modal';

type ServiceRecommendationModalProps = {
  children: ReactElement | string;
  isModalActive: boolean;
  handleModalClose: () => void;
  size?: 'lg' | 'sm' | 'md';
  heading: string;
  headingVariant:
    | 'display-xl'
    | 'display-lg'
    | 'display'
    | 'display-sm'
    | 'headline-lg'
    | 'headline';
};

export const ServiceRecommendationModal = ({
  isModalActive,
  handleModalClose,
  children,
  size,
  heading,
  headingVariant
}: ServiceRecommendationModalProps) => {
  return (
    <CatModal
      onBlModalClose={handleModalClose}
      isActive={isModalActive}
      heading={heading}
      headingVariant={headingVariant}
      size={size}
      data-testid="service-modal"
    >
      {children}
    </CatModal>
  );
};
